import {
  IconCheck,
  Modal,
  ModalContent,
  type ModalHook,
  useControlledModalState,
} from '@leland-dev/leland-ui-library';
import React, { type FC } from 'react';

import { type CoachingOutcomeInput } from '../../../__generated-gql-types__/globalTypes';
import { OutcomeForm } from '../OutcomeForm';

import { type OutcomeModalCategoryInformationFragment } from './__generated-gql-types__/OutcomeModal.generated';

interface OutcomeModalHookProps {
  categoryInfo: OutcomeModalCategoryInformationFragment[];
  coachName: string;
  defaultValues: CoachingOutcomeInput;
  refetchQueries?: RefetchQueriesType;
}

interface OutcomeModalProps extends OutcomeModalHookProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const OutcomeModalContent: FC<OutcomeModalProps> = ({
  open,
  setOpen,
  categoryInfo,
  coachName,
  defaultValues,
  refetchQueries,
}) => {
  return (
    <Modal open={open} onOpenChange={setOpen}>
      <ModalContent
        header={
          <div className="flex items-center justify-center space-x-2.5">
            <div className="flex size-6 items-center justify-center rounded-full bg-leland-primary">
              <IconCheck className="size-3.5 text-white" />
            </div>
            <p>Your review has been submitted</p>
          </div>
        }
        preventScroll
      >
        <OutcomeForm
          categoryInfo={categoryInfo}
          coachName={coachName}
          defaultValues={defaultValues}
          onClose={() => setOpen(false)}
          refetchQueries={refetchQueries}
        />
      </ModalContent>
    </Modal>
  );
};

export const useOutcomeModal: ModalHook<OutcomeModalHookProps> = () => {
  const [open, setOpen] = useControlledModalState();
  const OutcomeModal: FC<OutcomeModalHookProps> = (props) => {
    return open ? (
      <OutcomeModalContent {...props} open={open} setOpen={setOpen} />
    ) : null;
  };
  return { open, setOpen, Modal: OutcomeModal };
};
